import styled from "styled-components";

export const PageLogoLayoutStyled = styled.div`
  position: relative;
  margin: auto;
  max-width: ${({ theme }) => theme.SCREENS.MOBILE};
  .logo_mainlayout {
    padding-top: 24px;
    display: flex;
    justify-content: center;
  }
  .lang_mainlayout {
  }
  .body_mainlayout {
  }
`;
